import { BreadcrumbItem, Breadcrumb as ChakraBreadcrumb, Text } from '@chakra-ui/react'
import React from 'react'
import { FiChevronRight } from 'react-icons/fi'
import nextId from 'react-id-generator'
import { Link } from 'react-router-dom'

const notShowingBreadcrumbPath = ['/accessDenied']

const Breadcrumb = ({ routes }) => {
  const breadcrumbs = []

  const withoutRootBreadcrumbs = Array.isArray(breadcrumbs)
    ? breadcrumbs.slice(1).filter((breadcrumb) => !notShowingBreadcrumbPath.includes(breadcrumb.key))
    : []

  return (
    <ChakraBreadcrumb spacing="4px" separator={<FiChevronRight color="gray.500" />} px="10" py="3">
      {withoutRootBreadcrumbs.map((breadcrumb, index) => {
        if (index === breadcrumbs.length - 1) {
          return (
            <BreadcrumbItem key={nextId('breadcrumb_')}>
              <Text color={'gray'}>{breadcrumb.breadcrumb}</Text>
            </BreadcrumbItem>
          )
        }
        return (
          <BreadcrumbItem key={nextId('breadcrumb_')}>
            <Link to={breadcrumb.match.pathname}>
              <Text color={'blue'} _hover={{ textDecoration: 'underline' }}>
                {breadcrumb.breadcrumb}
              </Text>
            </Link>

            {/* {index === breadcrumbs.length - 1 && <span>{breadcrumb.breadcrumb}</span>} */}
          </BreadcrumbItem>
        )
      })}
    </ChakraBreadcrumb>
  )
}

export default Breadcrumb
